import RegisterFormPage from './RegisterFormPage';

export default RegisterFormPage;
